import { useContext } from 'react'

import { DayContext } from 'src/lib/dayContext'
import { NativeObjectTypes } from 'src/lib/objects'

import ObjectTile from '../ObjectTile/ObjectTile'

const ContactTile = ({
  email,
  displayName: _displayName,
  size: _size,
  showSidebar: _showSidebar,
  missingInfoExplanation: _missingInfoExplanation,
  subtitle: _subtitle,
}: {
  email: string
  displayName?: string
  size?: number
  showSidebar?: boolean
  missingInfoExplanation?: string
  subtitle?: boolean | string
}) => {
  const { selectedWorkspace } = useContext(DayContext)

  return (
    <ObjectTile
      objectType={NativeObjectTypes.Person}
      objectId={email}
      workspaceId={selectedWorkspace}
    />
  )
}

export default ContactTile
